<template lang="pug">
div
  div(v-if="ecommerce")
    div.px-2(v-if="ecommerce.sync_status === null")
      v-row
        v-col
          v-btn.white--text(block @click="syncAll" color="green" depressed) Import all products
    .sync-in-progress.mx-4(v-if="syncStatus === 'in_progress'")
      v-layout
        div.label.basic600--text.text-uppercase Update in progress
        div.ml-2.my-auto.grey--text {{ syncDone }} / {{ syncTotal }}
      v-layout.mt-4
        v-progress-linear(color="blue" height=6 rounded :value="syncDone/syncTotal*100")
        div.ml-2(style="margin-top:-11px")
          v-icon(small color="blue") mdi-progress-clock
    .sync-in-progress.mx-4(v-if="syncStatus === 'cancelled'")
      v-layout
        div.label.basic600--text.text-uppercase Update cancelled
        div.ml-2.my-auto.grey--text {{ syncDone }} / {{ syncTotal }}
      v-layout.mt-4
        v-progress-linear(color="warning" height=6 rounded :value="syncDone/syncTotal*100")
        div.ml-2(style="margin-top:-11px")
          v-icon(small color="warning") mdi-pause-circle-outline
    .sync-error.mx-4(v-if="syncStatus === 'error'")
      v-layout
        div.label.basic600--text.text-uppercase Error occured
        div.ml-2.my-auto.grey--text {{ syncDone }} / {{ syncTotal }}
      v-layout.mt-4
        v-progress-linear(color="error" height=6 rounded :value="syncDone/syncTotal*100")
        div.ml-2(style="margin-top:-11px")
          v-icon(small color="error") mdi-progress-alert
    .sync-completed.mx-4(v-if="syncStatus === 'done'")
      v-layout
        div.label.basic600--text.text-uppercase Sync products
        v-spacer
        div.ml-2.my-auto.c1.basic600--text {{ syncDone }} / {{ syncTotal }}
      v-layout.mt-4
        v-progress-linear(color="green" height=6 rounded :value="100")
        div.ml-2(style="margin-top:-11px")
          v-icon(small color="green") mdi-check-circle
      span.c1.basic600--text(v-if="ecommerce.sync_status.finished_at") Last updated on {{ ecommerce.sync_status.finished_at | convertServerDate }}
    div.px-2
      //v-list-item Last sync status: {{ settings.sync_status.status }} ({{settings.sync_status.processed}}/{{settings.sync_status.total_products}} updated)
      v-row(v-if="syncStatus === 'done'")
        v-col.mx-4
          v-btn.button-AA-medium.white--text(block @click="syncAll" color="info500" depressed) Update all products
      v-row(v-if="syncStatus === 'pending' || syncStatus === 'in_progress'")
        v-col.mx-4
          v-btn.button-AA-medium.white--text(block @click="stopSync" color="danger" depressed) Stop update
      v-row(v-if="syncStatus === 'cancelled' || syncStatus === 'error'")
        v-col(cols="6").mx-4
          v-btn.button-AA-medium.white--text(block @click="syncRetry" color="info500" depressed) Continue update
        v-col(cols="6").mx-4
          v-btn.button-AA-medium.white--text(block @click="syncAll" color="info500" depressed)  Restart update
</template>

<script>
import { mapActions } from "vuex"

export default {
  name: "WoocommerceProductSync",
  props: ['ecommerce'],
  data: (vm) => ({
    syncStatus: vm.ecommerce.sync_status.status,
    syncSource: vm.ecommerce.url,
    syncDone: vm.ecommerce.sync_status.processed,
    syncTotal: vm.ecommerce.sync_status.total_products
  }),
  watch: {
    ecommerce (val) {
      this.syncStatus = val.sync_status.status,
      this.syncSource = val.url,
      this.syncDone = val.sync_status.processed,
      this.syncTotal = val.sync_status.total_products
    }
  },
  mounted () {
    this.$wamp.subscribe(`woocommerce-sync-progress:${this.ecommerce.company}`, (args, kwArgs) => {
      this.syncSource = kwArgs.source
      this.syncStatus = kwArgs.status
      this.syncDone = kwArgs.done
      this.syncTotal = kwArgs.total
      if (kwArgs.status === 'done') {
        this.$axios.get(`/ecommerce/woocommerce/${this.ecommerce.id}/`)
          .then(resp => {
            this.$emit('update:ecommerce', resp.data)
          })
          .catch(() => {})
      }
    })
    if (this.ecommerce.sync_status.status === 'in_progress' || this.ecommerce.sync_status.status === 'error') {
      this.syncSource = this.ecommerce.url
      this.syncStatus = this.ecommerce.sync_status.status,
      this.syncDone = this.ecommerce.sync_status.processed,
      this.syncTotal = this.ecommerce.sync_status.total_products
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    syncAll () {
      this.$axios.post(`/ecommerce/woocommerce/${this.ecommerce.id}/sync_all/`)
        .then(resp => {
          this.$emit('update:ecommerce', resp.data)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_update_products')])
        })
    },
    syncRetry () {
      this.$axios.post(`/ecommerce/woocommerce/${this.ecommerce.id}/stop_and_resume_sync/`)
        .then(resp => {
          this.$emit('update:ecommerce', resp.data)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_resume_update')])
        })
    },
    stopSync () {
      this.$axios.post(`/ecommerce/woocommerce/${this.ecommerce.id}/stop_sync/`)
        .then(resp => {
          this.$emit('update:ecommerce', resp.data)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_stop_update')])
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>